import { mapActions } from 'vuex'
import Modal from '@/components/modals/modal/modal.vue'
import dateRangeFormMixin from '@/components/mixins/date-range-form-mixin'
import emitHideMixin from '@/components/modals/mixins/emit-hide'
import FiltersSelect from '@/components/filters-select/filters-select.vue'
import Loader from '@/components/loader/loader.vue'


const getDefaultDates = (startDate) => {
  const dateFrom = startDate ? new Date(startDate) : new Date()
  const dateTo = startDate ? new Date(startDate) : new Date()
  dateTo.setHours(dateTo.getHours() + 8)
  return {
    dateFrom,
    dateTo,
    manufacture: null,
    come_back: true
  }
}

export default {
  name: 'SendToGainModal',
  /**
   * emitHideMixin - методы hide и onHideModal
   */
  mixins: [dateRangeFormMixin, emitHideMixin],
  props: {
    dateFrom: {
      type: Date | Object
    },
    dateTo: {
      type: Date | Object
    }
  },
  components: {
    Modal,
    FiltersSelect,
    Loader
  },
  data() {
    return {
      form: getDefaultDates(),
      manufacturesOptions: [],
      pending: false
    }
  },
  methods: {
    ...mapActions({
      getManufacturesByCity: 'manufactures/getManufacturesByCity'
    }),
    show () {
      this.form.dateFrom = this.dateFrom ? this.dateFrom : new Date()
      this.form.dateTo = this.dateTo ? this.dateTo : getDefaultDates(this.form.dateFrom).dateTo
      this.loadManufacturesOptions()
      this.$refs.modal.show()
    },
    closeDatePickers(event) {
      ['datepicker1', 'datepicker2'].forEach(key => {
        this.$refs[key].$children[0].handleClickOutSide(event)
      })
    },
    onSubmitSuccess() {
      const sendData = {
        manufacture_id: this.form.manufacture.id,
        datetime_start: this.$moment.utc(this.form.dateFrom).format(),
        datetime_end: this.$moment.utc(this.form.dateTo).format(),
        come_back: this.form.come_back
      }
      this.$emit('submit', sendData)
      this.hide()
    },
    async loadManufacturesOptions() {
      this.pending = true
      try {
        const res = await this.getManufacturesByCity()
        this.manufacturesOptions = res
      } finally {
        this.pending = false
      }
    },
    changeComeback() {
      this.form.come_back = !this.form.come_back
    }
  }
}
